import React from 'react'
// components
import Home from 'components/PageComponents/Home'

const HomePage: React.FC = () => <Home />

export default HomePage
